/*
 * pedag: doporučení v postranním košíku
 * 1) doplňkové produkty (Search & Discovery → Doplňkové) – zkouší postupně
 *    produkty v košíku, dokud některý nějaké doplňky nemá
 * 2) když žádný nemá → záloha z kolekce "nejprodavanejsi"
 * Produkty, které už jsou v košíku, se nikdy nenabízejí.
 */
class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this._run = 0;
		this.generateRecommendations();
	}

	async generateRecommendations(){
		const run = ++this._run;
		const cartForm = document.getElementById('AjaxCartForm');
		if ( ! cartForm ) return;

		const cartItems = cartForm.querySelectorAll('[data-js-cart-item]');
		if ( cartItems.length === 0 ) return;

		const section = this.dataset.section;
		const limit = parseInt(this.dataset.limit) || 6;
		const inCart = new Set(Array.from(cartItems).map(item => item.dataset.productId));

		// 1) doplňkové produkty
		for ( const productId of inCart ) {
			const url = `${KROWN.settings.routes.product_recommendations_url}?section_id=${section}&product_id=${productId}&limit=10&intent=complementary`;
			if ( await this.renderFrom(url, inCart, limit, run) ) return;
		}

		// 2) záloha – nejprodávanější
		const root = ( window.Shopify && Shopify.routes && Shopify.routes.root ) || '/';
		await this.renderFrom(`${root}collections/nejprodavanejsi?section_id=${section}`, inCart, limit, run);
	}

	async renderFrom(url, inCart, limit, run){
		try {
			const text = await fetch(url).then(response => response.text());
			if ( run !== this._run ) return true; // mezitím se košík změnil, starý výsledek zahodit

			const wrapper = new DOMParser()
				.parseFromString(text, 'text/html')
				.querySelector('[data-js-cart-recommendations-performed]');
			if ( ! wrapper ) return false;

			let shown = 0;
			wrapper.querySelectorAll('[data-js-product-item]').forEach(item => {
				if ( inCart.has(item.dataset.productId) || shown >= limit ) {
					item.remove();
				} else {
					shown++;
				}
			});
			if ( shown === 0 ) return false;

			this.innerHTML = wrapper.innerHTML;
			return true;
		} catch (e) {
			console.warn(e);
			return false;
		}
	}
}
customElements.define('cart-recommendations', CartRecommendations);